import { useOutletContext } from 'react-router-dom';

export interface CustomerOutletContextType {
  customerId: string;
  customerReference: string;
  orderId?: string | undefined; // if part of editing an order
}
export interface OrderOutletContextType {
  orderId: string;
  orderNumber: string;
  customerId: string;
  vehicleId: string;
  fulfilmentBaseLocationId: string;
  referenceId?: string;
}

export interface FleetOutletContextType {
  accountNumber: string;
}

export const useCustomerOutletContext =
  useOutletContext<CustomerOutletContextType>;

export const useOrderOutletContext = useOutletContext<OrderOutletContextType>;

export const useFleetOutletContext = useOutletContext<FleetOutletContextType>;
